<template>
    <v-container class="pa-0 mt-n2 table-container">
        <div class="graph organism-graph">
            <p class="text-center">{{$t('totalProjectsByOrganism')}}</p>
            <svg class="barchart" :width="width + 40" :height="height + 100">
                <g transform="translate(20, 20)">
                    <g class="x-axis" fill="none" :transform="`translate(0, ${height})`">
                        <path stroke="#ddd" :d="`M0.5,6V0.5H${width}.5V6`" :stroke-width="3"></path>
                        <g
                            class="tick"
                            opacity="1"
                            font-size="10"
                            font-family="sans-serif"
                            text-anchor="middle"
                            v-for="(bar, index) in bars"
                            :key="index"
                            :transform="`translate(${bar.x + bar.width / 2}, 0)`"
                            >
                            <line stroke="currentColor" y2="6"></line>
                            <text fill="currentColor" y="15" x="35" class="text-rotate">{{ bar.xLabel }}</text>
                        </g>
                    </g>
                    <g class="y-axis" fill="none" :transform="`translate(0, 0)`">
                        <path class="domain" stroke="#ddd" :d="`M0.5,${height}.5H0.5V0.5H-6`" :stroke-width="4"></path>
                        <g
                        class="tick"
                        opacity="1"
                        font-size="10"
                        font-family="sans-serif"
                        text-anchor="end"
                        v-for="(tick, index) in yTicks"
                        :key="index"
                        :transform="`translate(0, ${y(tick) + 0.5})`"
                        >
                        <line stroke="#ddd" x2="-6"></line>
                        <text fill="currentColor" x="-9" dy="0.32em">{{ tick }}</text>
                        </g>
                    </g>
                    <g class="bars" fill="none">
                        
                        <rect
                        v-for="(bar, index) in bars"
                        fill="#C3D7E2"
                        :key="index"
                        :height="bar.height"
                        :width="bar.width"
                        :x="bar.x"
                        :y="bar.y"
                        rx="5" ry="5"
                        ></rect>
                        <br>
                        <text :x="bar.x+5" :y="bar.y-5" rx="5" ry="5" font-size="12" fill="#555" v-for="(bar) in bars" :key="bar.name">{{bar.total}}</text>

                    </g>
                </g>
                </svg>
        </div>
        <div class="graph status-graph">
            <p class="text-center">{{$t('totalProjectsByStatus')}}</p>
            <svg class="barchart" :width="width + 40" :height="height + 100">
                <g transform="translate(20, 20)">
                    <g class="x-axis" fill="none" :transform="`translate(0, ${height})`">
                        <path stroke="#ddd" :d="`M0.5,6V0.5H${width}.5V6`" :stroke-width="3"></path>
                        <g
                            class="tick"
                            opacity="1"
                            font-size="10"
                            font-family="sans-serif"
                            text-anchor="middle"
                            v-for="(bar, index) in barsS"
                            :key="index"
                            :transform="`translate(${bar.x + bar.width / 2}, 0)`"
                            >
                            <line stroke="currentColor" y2="6"></line>
                            <text fill="currentColor" y="15" x="35"  class="text-rotate" >{{ $t('resultStatus.'+bar.xLabel) }}</text>
                        </g>
                    </g>
                    <g class="y-axis" fill="none" :transform="`translate(0, 0)`">
                        <path class="domain" stroke="#ddd" :d="`M0.5,${height}.5H0.5V0.5H-6`" :stroke-width="4"></path>
                        <g
                        class="tick"
                        opacity="1"
                        font-size="10"
                        font-family="sans-serif"
                        text-anchor="end"
                        v-for="(tick, index) in yTicksS"
                        :key="index"
                        :transform="`translate(0, ${yS(tick) + 0.5})`"
                        >
                        <line stroke="#ddd" x2="-6"></line>
                        <text fill="currentColor" x="-9" dy="0.32em">{{ tick }}</text>
                        </g>
                    </g>
                    <g class="bars" fill="none">
                        <rect
                        v-for="(bar, index) in barsS"
                        fill="#C3D7E2"
                        :key="index"
                        :height="bar.height"
                        :width="bar.width"
                        :x="bar.x"
                        :y="bar.y"
                        rx="5" ry="5"
                        ></rect>
                        <text :x="bar.x+5" :y="bar.y-5" rx="5" ry="5" font-size="12" fill="#555" v-for="(bar) in barsS" :key="bar.name">{{bar.total}}</text>
                    </g>
                </g>
            </svg>
        </div>        
    </v-container>
</template>

<script>
import { scaleLinear, scaleBand } from "d3-scale";
export default {
  components:{

  },
  data () {
    return {
        height: 360,
        width: (window.innerWidth/3)-85,
        dataOrganisms: [],
        dataStatus: [],
        startDate: '',
        range: 'day',
        rectWidth: 20
    }
  },
  computed:{
    yTicks() {
        return this.y.ticks(6);
    },
    yTicksS() {
        return this.yS.ticks(6);
    },
    x() {
        return scaleBand()
        .range([0, this.width])
        .padding(0.3)
        .domain(this.dataOrganisms.map(e => e[0]));
    },
    xS() {
        return scaleBand()
        .range([0, this.width])
        .padding(0.3)
        .domain(this.dataStatus.map(e => e[0]));
    },
    y() {
        let values = this.dataOrganisms.map(e => e[1]);
        return scaleLinear()
        .range([this.height, 0])
        .domain([0, Math.max(...values)]);
    },
    yS() {
        let values = this.dataStatus.map(e => e[1]);
        return scaleLinear()
        .range([this.height, 0])
        .domain([0, Math.max(...values)]);
    },
    bars() {
        let bars = this.dataOrganisms.map(d => {
            
        return {
            xLabel: d[0],
            x: this.x(d[0]),
            y: this.y(d[1]),
            width: this.rectWidth,
            height: this.height - this.y(d[1]),
            total: d[1],
            name: d[0]
        };
        });
        return bars;
    },
    barsS() {
        let bars = this.dataStatus.map(d => {
        return {
            xLabel: d[0],
            x: this.xS(d[0]),
            y: this.yS(d[1]),
            width: this.rectWidth,
            height: this.height - this.yS(d[1]),
            total: d[1],
            name: d[0]
        };
        });
        return bars;
    },
    search: {
        get(){
            return this.$store.getters.getSearch
        },
        set(value){
            return this.$store.commit('setSearch', value)
        }
    },
    start: {
      get(){
        return this.$store.getters.getStartDate
      },
      set(value){
        return this.$store.commit('setStartDate', value)
      }
    },
    rangeDates: {
        get(){
            return this.$store.getters.getRange
        },
        set(value){
        return this.$store.commit('setRange', value)
      }
    }
  },
  watch: {
    start: function(newVal, oldVal) { // watch it
        this.startDate = newVal
        if(newVal != oldVal){
            this.getStatisticsGraph()
            this.getStatisticsStatusGraph()
        }
    },
    rangeDates: function(newVal, oldVal) { // watch it
        this.range = newVal
        if(newVal != oldVal){
            this.getStatisticsGraph()
            this.getStatisticsStatusGraph()
        }
    },
    search: function(newVal, oldVal) { 
        this.search = newVal
        if(newVal != oldVal){
            this.getStatisticsGraph()
            this.getStatisticsStatusGraph()
        }
    }
  },
  created(){
      this.startDate = this.$store.getters.getStartDate
      this.range = this.$store.getters.getRange
  },
  mounted(){
    this.getStatisticsGraph()
    this.getStatisticsStatusGraph()
    if(window.innerWidth > 3200){
        this.width = (window.innerWidth/3)-450
        this.rectWidth = 20
        this.rectWidth = 20
    }
    if(window.innerWidth > 2500 && window.innerWidth <= 3200){
        this.width = (window.innerWidth/3)-300
    }
    if(window.innerWidth > 2000 && window.innerWidth <= 2500) {
        this.width = (window.innerWidth/3)-150
        this.rectWidth = 20
        this.rectWidth = 20
    }
    if(window.innerWidth > 1700 && window.innerWidth <= 2000) {
        this.width = (window.innerWidth/3)-180
        this.rectWidth = 20
        this.rectWidth = 20
    }
    if(window.innerWidth > 1264 && window.innerWidth <= 1700) {
        this.width = (window.innerWidth/3)-150
        this.rectWidth = 20
        this.rectWidth = 20
    }
    if(window.innerWidth > 500 && window.innerWidth <= 1264){
            this.width = (window.innerWidth/2)
            this.height = 300
            this.rectWidth = 15
            this.rectWidth = 15
    }
    if(window.innerWidth <= 500){
            this.width = (window.innerWidth/3)
            this.height= 250
            this.rectWidth = 10
            this.rectWidth = 10
    }
    window.onresize = () => {
        if(window.innerWidth > 3200){
            this.width = (window.innerWidth/3)-450
        }
        if(window.innerWidth > 2500 && window.innerWidth <= 3200){
            this.width = (window.innerWidth/3)-300
            this.rectWidth = 20
            this.rectWidth = 20
        }
        if(window.innerWidth > 2000 && window.innerWidth <= 2500 ){
            this.width = (window.innerWidth/3)-150
            this.rectWidth = 20
            this.rectWidth = 20
        }
        if(window.innerWidth > 1700 && window.innerWidth <= 2000) {
            this.width = (window.innerWidth/3)-180
            this.rectWidth = 20
            this.rectWidth = 20
        }
        if(window.innerWidth > 1264 && window.innerWidth <= 1700) {
            this.width = (window.innerWidth/3)-150
            this.rectWidth = 20
            this.rectWidth = 20
        }
        if(window.innerWidth > 500 && window.innerWidth <= 1264){
            this.width = (window.innerWidth/2)
            this.height = 300
            this.rectWidth = 15
            this.rectWidth = 15
        }
        if(window.innerWidth <= 500){
            this.width = (window.innerWidth/3)
            this.height = 250
            this.bars.width = 10
            this.rectWidth = 10
        }
    }
  },
  methods: {
    getStatisticsGraph(){
        this.$extractions.getStatisticsGraph(this.search,this.startDate, this.range).then(response=>{
            let organisms = []
            response.data.forEach(o => {
                let data = []
                data.push(o.organismName)
                data.push(o.totalProjects)
                organisms.push(data)
                
            })
            this.dataOrganisms = organisms 

        }).catch(e=>{
            console.log('Error: ', e)
        }) 
    },
    getStatisticsStatusGraph(){
        this.$extractions.getStatisticsStatusGraph(this.search, this.startDate, this.range).then(response=>{
           let status = []
            response.data.forEach(st => {
                let data = []
                data.push(st.status)
                data.push(st.totalProjects)
                status.push(data)
            })
            this.dataStatus = status

        }).catch(e=>{
            console.log('Error: ', e)
        }) 
    }
  }
}

</script>
<style>
    
    .graph{
        border: 3px solid #eee;
        padding: 20px;
        display: inline-block;
    }
    .table-container{
        max-width: 98%!important;
        text-align: center!important;
    }
    .text-rotate {
        transform: rotateZ(50deg)!important;
        height: 100px!important;
        transform-origin: top left;
    }
    .organism-graph{
        margin-right: 8px!important;
    }
    @media (max-width: 3100px) {
        .barchart{
            margin-left: 15px!important
        }
    }
    @media (max-width: 1264px) {
        .status-graph{
            margin-top: 20px!important;
            margin-left: -15px!important;
        }
        .organism-graph{
            margin-right: 0px!important;
            margin-left: -15px!important;
        }
    }
    @media (max-width: 600px) {
        .graph{
            margin: 0!important;
        }
        .table-container{
            max-width: 100%!important;
        }
        .status-graph{
            width: 100%!important;
        }
        .organism-graph{
            width: 100%!important;
        }   
    }
</style>